import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { ComponentsModule } from "components/components.module";
import { IonicPageModule } from "ionic-angular";
import { HoldBenefitPopover } from "./hold-benefit-popover/hold-benefit-popover";
import { PatientBenefitsPage } from "./patient-benefits";
import { PatientBenefitsAuthorizationComponent } from "./patient-benefits-authorization/patient-benefits-authorization";
import { PatientBenefitsCrudComponent } from "./patient-benefits-crud/patient-benefits-crud";
import { PatientBenefitsFormComponent } from "./patient-benefits-form/patient-benefits-form";
import { PatientBenefitsRowComponent } from "./patient-benefits-row/patient-benefits-row";
import { PatientBenefitsTableComponent } from "./patient-benefits-table/patient-benefits-table";
import { PatientEligibilityRowComponent } from "./patient-eligibility-row/patient-eligibility-row";
import { PatientEligibility } from "./patient-eligibility/patient-eligibility";

@NgModule({
  entryComponents: [PatientBenefitsPage, HoldBenefitPopover],
  declarations: [
    PatientBenefitsPage,
    PatientBenefitsFormComponent,
    PatientBenefitsTableComponent,
    PatientBenefitsAuthorizationComponent,
    HoldBenefitPopover,
    PatientBenefitsRowComponent,
    PatientBenefitsCrudComponent,
    PatientEligibility,
    PatientEligibilityRowComponent,
  ],
  imports: [
    IonicPageModule.forChild(PatientBenefitsPage),
    TranslateModule.forChild(),
    CommonComponentsModule,
    NgSelectModule,
    ComponentsModule,
    ReactiveFormsModule,
  ],
  exports: [PatientBenefitsCrudComponent, PatientEligibility],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PatientBenefitsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-benefits/patient-benefits.module.ts